<template lang="pug">
.introduction-container
   iframe.iframe-block(:src="ruleLink")
</template>
<script>
export default {
  props: {},
  data() {
    return {
      ruleLink: '',
    };
  },
  created() {
    const { ruleLink } = this.$route.query;
    this.ruleLink = ruleLink;
  },
};
</script>
<style lang="less" scoped>
.introduction-container {
  height: 100%;

  .iframe-block {
    width: 100%;
    height: 100%;
  }
}
</style>
